import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { baseUrl } from "../../../config/baseUrl";
import { Link } from "react-router-dom";
import EduPagination from "../../edu-pagination/edu-pagination";
import buildingImg from "../../../assets/images/building_burz.png";
import loadergif from "../../../assets/images/model-loader.gif";

function AddHealthSafetyPolicy({ show, onClose, onSuccess }) {
  const [policy, setPolicy] = useState("");
  const [policyFile, setPolicyFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const fileInputRef = useRef();
  const modalRef = useRef();

  useEffect(() => {
    setPolicy("");
    setPolicyFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  }, [show]);

  // Close modal on outside click or ESC
  useEffect(() => {
    if (!show) return;
    function handleClick(e) {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    }
    function handleEsc(e) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [show, onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const formData = new FormData();
      formData.append("policy", policy);
      formData.append("policy_document", policyFile);
      await axios.post(`${baseUrl}/create_college_health_policy/`, formData, {
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      });
      setPolicy("");
      setPolicyFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
      if (onSuccess) onSuccess();
      if (onClose) onClose();
    } catch (err) {
      setError("Failed to add policy.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {show && (
        <div
          className={`modal fade custom-modal addcollege-modal${
            show ? " show d-block" : ""
          }`}
          id="addHealthPolicyModal"
          tabIndex={-1}
          aria-labelledby="addHealthPolicyModalLabel"
          aria-hidden={!show}
          style={{ background: show ? "rgba(0,0,0,0.5)" : undefined }}
          data-bs-backdrop="false"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-fullscreen">
            <div className="modal-content" ref={modalRef}>
              <div className="modal-header justify-content-center">
                <h5 className="modal-title">Add Health Safety Policy</h5>
                <button
                  type="button"
                  className="modal-close"
                  aria-label="Close"
                  onClick={onClose}
                >
                  <i className="fa fa-times" />
                </button>
              </div>
              <div className="modal-body">
                <div className="d-flex flex-row justify-content-center align-items-center">
                  <div className="col-lg-5 text-center">
                    <div className="addbus-modal-innr">
                      <img
                        src={buildingImg}
                        width="336"
                        height="336"
                        alt="add-health-policy"
                      />
                      <form onSubmit={handleSubmit}>
                        <div className="row justify-content-center">
                          <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                            <label className="form-label">Policy</label>
                            <input
                              type="text"
                              className="form-control"
                              value={policy}
                              onChange={(e) => setPolicy(e.target.value)}
                              required
                            />
                          </div>
                          <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                            <label className="form-label">
                              Policy Document
                            </label>
                            <input
                              type="file"
                              className="form-control"
                              ref={fileInputRef}
                              onChange={(e) => setPolicyFile(e.target.files[0])}
                              required
                            />
                          </div>
                          <div className="frm-bx mb-4 col-lg-8 mb-3">
                            <button
                              className="thm-btn"
                              type="submit"
                              disabled={loading}
                            >
                              {loading ? "Adding..." : "Add Policy"}
                            </button>
                          </div>
                          {error && (
                            <div className="col-12 text-danger">{error}</div>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function EditHealthSafetyPolicy({ show, onClose, policyObj, onSuccess }) {
  const [policy, setPolicy] = useState(policyObj?.policy || "");
  const [policyFile, setPolicyFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const fileInputRef = useRef();
  const modalRef = useRef();

  useEffect(() => {
    setPolicy(policyObj?.policy || "");
    setPolicyFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  }, [policyObj, show]);

  // Close modal on outside click or ESC
  useEffect(() => {
    if (!show) return;
    function handleClick(e) {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    }
    function handleEsc(e) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [show, onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const formData = new FormData();
      formData.append("policy", policy);
      if (policyFile) formData.append("policy_document", policyFile);
      await axios.patch(
        `${baseUrl}/update_college_health_policy/${policyObj.id}/`,
        formData,
        {
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setPolicyFile(null);
      setPolicy("");
      if (fileInputRef.current) fileInputRef.current.value = "";
      if (onSuccess) onSuccess();
      if (onClose) onClose();
    } catch (err) {
      setError("Failed to update policy.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`modal fade custom-modal addcollege-modal${
        show ? " show d-block" : ""
      }`}
      id="editHealthPolicyModal"
      tabIndex={-1}
      aria-labelledby="editHealthPolicyModalLabel"
      aria-hidden={!show}
      style={{ background: show ? "rgba(0,0,0,0.5)" : undefined }}
      data-bs-backdrop="false"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content" ref={modalRef}>
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">Edit Health Safety Policy</h5>
            <button
              type="button"
              className="modal-close"
              aria-label="Close"
              onClick={onClose}
            >
              <i className="fa fa-times" />
            </button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-row justify-content-center align-items-center">
              <div className="col-lg-5 text-center">
                <div className="addbus-modal-innr">
                  <img
                    src={buildingImg}
                    width="336"
                    height="336"
                    alt="edit-health-policy"
                  />
                  <form onSubmit={handleSubmit}>
                    <div className="row justify-content-center">
                      <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                        <label className="form-label">Policy</label>
                        <input
                          type="text"
                          className="form-control"
                          value={policy}
                          onChange={(e) => setPolicy(e.target.value)}
                          required
                        />
                      </div>
                      <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                        <label className="form-label">
                          Policy Document (leave blank to keep existing)
                        </label>
                        {policyObj?.policy_document ? (
                          <div className="mb-2">
                            {/\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i.test(
                              String(policyObj.policy_document)
                            ) ? (
                              <img
                                src={policyObj.policy_document}
                                alt="Current Policy"
                                style={{
                                  maxWidth: "100%",
                                  height: "auto",
                                  maxHeight: 200,
                                }}
                              />
                            ) : String(policyObj.policy_document)
                                .toLowerCase()
                                .endsWith(".pdf") ? (
                              <iframe
                                src={policyObj.policy_document}
                                width="100%"
                                height="200"
                                title="Current Policy"
                              />
                            ) : (
                              <a
                                href={policyObj.policy_document}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-info btn-sm"
                              >
                                View Uploaded document
                              </a>
                            )}
                          </div>
                        ) : null}
                        <input
                          type="file"
                          className="form-control"
                          ref={fileInputRef}
                          onChange={(e) => setPolicyFile(e.target.files[0])}
                        />
                      </div>
                      <div className="frm-bx mb-4 col-lg-8 mb-3">
                        <button
                          className="thm-btn"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? "Updating..." : "Update Policy"}
                        </button>
                      </div>
                      {error && (
                        <div className="col-12 text-danger">{error}</div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function DeleteHealthSafetyPolicyModal({ show, onClose, onConfirm }) {
  const modalRef = useRef();
  // Close modal on outside click or ESC
  useEffect(() => {
    if (!show) return;
    function handleClick(e) {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    }
    function handleEsc(e) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [show, onClose]);
  return (
    <div
      className={`modal fade${show ? " show d-block" : ""}`}
      id="deleteHealthPolicyModal"
      tabIndex={-1}
      aria-labelledby="deleteHealthPolicyModalLabel"
      aria-hidden={!show}
      style={{ background: show ? "rgba(0,0,0,0.5)" : undefined }}
      data-bs-backdrop="false"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" ref={modalRef}>
          <div className="modal-body">
            <div className="modal-trash">
              <img src={loadergif} alt="delete" className="w-100" />
              <h4>Are you sure you want to delete this policy?</h4>
              <div className="modal-trash-btn">
                <button className="btn btn-outline-info" onClick={onClose}>
                  Cancel
                </button>
                <button className="btn btn-outline-danger" onClick={onConfirm}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function EduHealthSafetyPolicyList() {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editPolicy, setEditPolicy] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletePolicyId, setDeletePolicyId] = useState(null);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    async function fetchPolicies() {
      setLoading(true);
      setError("");
      try {
        const res = await axios.get(
          `${baseUrl}/get_college_health_policy/?per_page=${pageLimit}&page=${pageNumber}`,
          {
            headers: {
              Authorization: "Token " + localStorage.getItem("token"),
            },
          }
        );
        if (res.data && res.data.data) {
          setPolicies(res.data.data);
          setTotalCount(res.data.count || 0);
        } else {
          setPolicies([]);
          setTotalCount(0);
        }
      } catch (err) {
        setError("Failed to fetch health safety policies.");
        setPolicies([]);
        setTotalCount(0);
      } finally {
        setLoading(false);
      }
    }
    fetchPolicies();
  }, [pageNumber, pageLimit, refresh]);

  const handleDelete = async () => {
    if (!deletePolicyId) return;
    try {
      await axios.delete(
        `${baseUrl}/delete_college_health_policy/${deletePolicyId}/`,
        {
          headers: { Authorization: "Token " + localStorage.getItem("token") },
        }
      );
      setShowDeleteModal(false);
      setDeletePolicyId(null);
      setRefresh((r) => !r);
    } catch (err) {
      setShowDeleteModal(false);
      setDeletePolicyId(null);
    }
  };

  return (
    <section className="main-sec">
      <div className="row">
        <div className="col-lg-12">
          <div className="dashboard-title">
            <h4 className="dash-head">
              <i className="fa fa-chart-bar me-2" />
              Health Safety Policy List
            </h4>
          </div>
          <div className="custom-bredcump">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/education">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Health Safety Policy List
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="cards bus-list">
            <div className="d-flex flex-row justify-content-between align-items-center mb-3">
              <div></div>
              <button className="blu-btn" onClick={() => setShowAddModal(true)}>
                <i className="fa fa-plus me-2" /> Add Health Safety Policy
              </button>
            </div>
            {showAddModal && (
              <AddHealthSafetyPolicy
                show={showAddModal}
                onClose={() => setShowAddModal(false)}
                onSuccess={() => {
                  setShowAddModal(false);
                  setRefresh((r) => !r);
                }}
              />
            )}
            {showEditModal && (
              <EditHealthSafetyPolicy
                show={showEditModal}
                onClose={() => setShowEditModal(false)}
                policyObj={editPolicy}
                onSuccess={() => {
                  setShowEditModal(false);
                  setRefresh((r) => !r);
                }}
              />
            )}
            {showDeleteModal && (
              <DeleteHealthSafetyPolicyModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={handleDelete}
              />
            )}
            <div className="table table-responsive custom-table">
              <table className="table table-borderless">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Policy</th>
                    <th>Company</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="6">Loading...</td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="6" className="text-danger">
                        {error}
                      </td>
                    </tr>
                  ) : policies.length > 0 ? (
                    policies.map((policy, i) => {
                      const dateObj = new Date(policy.created_at);
                      const dateStr = dateObj.toLocaleDateString();
                      const timeStr = dateObj.toLocaleTimeString();

                      return (
                        <tr key={policy.id}>
                          <td>{i + 1 + pageLimit * (pageNumber - 1)}</td>
                          <td>
                            {typeof policy.policy === "object"
                              ? policy.policy?.policy || policy.policy?.name
                              : policy.policy}
                          </td>
                          <td>
                            {typeof policy.company === "object"
                              ? policy.company?.company_name ||
                                policy.company?.name
                              : policy.company}
                          </td>
                          <td>{dateStr}</td>
                          <td>{timeStr}</td>
                          <td>
                            <button
                              className="btn btn-outline-warning btn-sm me-2"
                              onClick={() => {
                                setEditPolicy(policy);
                                setShowEditModal(true);
                              }}
                              title="Update"
                            >
                              <i className="fa fa-edit" />
                            </button>
                            <button
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => {
                                setDeletePolicyId(policy.id);
                                setShowDeleteModal(true);
                              }}
                              title="Delete"
                            >
                              <i className="fa fa-trash" />
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="6">No policies found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
              <EduPagination
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
                totalCount={totalCount}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
